export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5285.9f0e1cd0.jpg";